const analytics = {
  gtag (command, action, category, label) {
    window.gtag(command, action, {'event_category': category, 'event_label': label})
  }
}

export default analytics
